module.exports = __webpack_public_path__ + "static/media/gerbrock_small.34c0c753.png";